import { axios, AxiosResponse } from "@sdk/axios";
import type {
  MyPerformanceRequest,
  MyPerformanceResponse,
} from "./my-performance.models";

export async function fetchMyPerformance(
  config: { basePath: string; token: string },
  req: MyPerformanceRequest
): Promise<MyPerformanceResponse> {
  const results: AxiosResponse<MyPerformanceResponse> = await axios.post(
    `${config.basePath}/crm/reports/my-performance`,
    req,
    { headers: { Authorization: config.token } }
  );
  return results.data;
}
